export const CustomerTierPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">티어 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select w-150px">
                                <option>CLA Number</option>
                            </select>
                            <input type="text"
                                className="form-control"
                            />
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                    </div>
                    <div className="col-6"></div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">티어 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-outline-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export_white.png"} alt="" />엑셀 내보내기</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th rowSpan={2} style={{ width: "3.76%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th rowSpan={2} style={{ width: "12.9%" }}>CLA Number<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                                <th rowSpan={2} style={{ width: "11.82%" }}>Company ID<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" /></th>
                                <th colSpan={2} style={{ width: "22.5%" }}>고객</th>
                                <th rowSpan={2} style={{ width: "8.06%" }}>Company Legal Name</th>
                                <th rowSpan={2} style={{ width: "9.6%" }}>Parent Company ID</th>
                                <th rowSpan={2} style={{ width: "10.2%" }}>Pricing Group</th>
                                <th rowSpan={2} style={{ width: "7.52%" }}>Price Tier</th>
                                <th rowSpan={2}>ERP 코드</th>
                            </tr>
                            <tr>
                                <th style={{ width: "11.25%" }}>거래처<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                                <th style={{ width: "11.25%" }}>ERP 거래처<img src={process.env.PUBLIC_URL + "/assets/images/icon-table-sort-down.png"} alt="" />​</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(() => (
                                <tr>
                                    <td>
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                    <td className="text-center"></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}